/* Keep the native selector and visual offers in sync without replacing the cart flow. */
(() => {
 'use strict';
 document.querySelectorAll('.cm-product-page .cm-purchase-form').forEach(form => {
  const select = form.querySelector('select[name="id"]');
  if (!select) return;
  const button = form.querySelector('[name="add"]');
  const radios = [...form.querySelectorAll('.cm-variant-radios input[type="radio"]')];
  const syncAvailability = () => {
   if (button && !button.hasAttribute('aria-busy')) button.disabled = Boolean(select.selectedOptions[0]?.disabled);
  };
  select.addEventListener('change', () => {
   const match = radios.find(radio => radio.value === select.value);
   if (match && !match.checked) {
    radios.forEach(radio => { radio.checked = radio === match; });
    match.dispatchEvent(new Event('change', { bubbles: true }));
   }
   syncAvailability();
  });
  radios.forEach(radio => radio.addEventListener('change', syncAvailability));
  syncAvailability();
 });
})();
